import { useNavigate } from "react-router-dom";
import { GetDepartmentForCoordinator } from "../../../lib/api";
import { useQuery } from "@tanstack/react-query";
import { ShowLoadingAnimation } from "../../../components/common/Animation";
import Cookies from "js-cookie";
import { useEffect } from "react";

const AvailableCounter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const stored = localStorage.getItem("CurrentCounter");
    if (stored) {
      try {
        const currentCounter = JSON.parse(stored);
        navigate(`/counter/${currentCounter?.counter?.CounterID}`, {
          state: {
            userCounterData: currentCounter?.counter,
            DepId: currentCounter?.DepId,
          },
        });
      } catch (e) {
        console.error("Invalid JSON in localStorage:", e);
      }
    }
  }, [navigate]);

  const { isLoading, isPending, data } = useQuery({
    queryKey: ["GetDepartmentForCoordinator"],
    queryFn: () => GetDepartmentForCoordinator(),
  });

  const filteredData = data?.data?.counters?.filter(
    (item) => item.Status === true
  );

  if (filteredData?.length === 1) {
    if (Cookies.get("isCustomCall") === "true") {
      navigate(`/custom-counter/${filteredData[0]?.CounterID}`, {
        state: { userCounterData: filteredData[0] },
      });
    } else {
      navigate(`/counter/${filteredData[0]?.CounterID}`, {
        state: { userCounterData: filteredData[0] },
      });
    }
  }

  const handleNavigation = (counter, DepId, DepPrefix) => {
    Cookies.set("DepId", DepId);
    Cookies.set("DepPrefix", DepPrefix);
    Cookies.set("CounterID", counter.CounterID);
    localStorage.setItem(
      "CurrentCounter",
      JSON.stringify({ counter, DepId, DepPrefix })
    );
    if (Cookies.get("isCustomCall") === true) {
      navigate(`/custom-counter/${counter.CounterID}`, {
        state: { userCounterData: counter, DepId: DepId },
      });
    } else {
      navigate(`/counter/${counter.CounterID}`, {
        state: { userCounterData: counter, DepId: DepId },
      });
    }
  };

  const isExpired = (expireDate) => {
    const currentDate = new Date();
    const depExpireDate = new Date(expireDate);
    return depExpireDate <= currentDate;
  };

  const activeDepartments =
    data?.data?.department?.filter(
      (dept) => dept.Status === true
    ) || [];

  if (activeDepartments.length === 1) {
    const department = activeDepartments[0];
    if (
      !isExpired(department.DepExpire) &&
      department?.Counters?.length === 1
    ) {
      const counter = department.Counters[0];
      handleNavigation(counter, department.DepID, department.DepPrefix);
      return null;
    }
  }

  return (
    <div className="py-10 px-4 lg:px-8 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h4 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
          Select Your Operating Section
        </h4>
        <p className="mt-3 text-gray-600 text-lg">
          Choose a department and counter to proceed
        </p>
      </div>

      {isLoading && isPending && (
        <div className="w-44 m-auto">
          <ShowLoadingAnimation />
        </div>
      )}

      <div className="space-y-8">
        {activeDepartments.map((dept) => {
          const expired = isExpired(dept.DepExpire);

          return (
            <div
              key={dept.DepID}
              className="bg-white rounded-2xl shadow-lg p-6"
            >
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl lg:text-3xl font-bold text-gray-800">
                  {dept.DepName} ({dept.DepPrefix})
                </h3>
                <span
                  className={`text-sm font-semibold ${expired ? "text-red-500" : "text-green-500"
                    }`}
                >
                  {expired ? "Expired" : "Active"}
                </span>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {dept?.Counters?.map((Counter, index) => {
                  const isDisabled = expired;

                  return (
                    <div
                      key={index + 1}
                      onClick={() =>
                        !isDisabled &&
                        handleNavigation(Counter, dept.DepID, dept.DepPrefix)
                      }
                      className={`group relative bg-gradient-to-br ${isDisabled
                        ? "from-gray-100 to-gray-200 cursor-not-allowed"
                        : "from-blue-50 to-purple-50 hover:from-blue-100 hover:to-purple-100 cursor-pointer"
                        } rounded-2xl p-6 text-center transition-all duration-300 transform hover:scale-105 hover:shadow-lg`}
                    >
                      <p className="text-xl font-bold text-gray-800 mb-2">
                        {Counter.CounterName}
                      </p>

                      {!isDisabled && (
                        <span className="text-sm text-gray-600">
                          Click to proceed
                        </span>
                      )}

                      {!isDisabled && (
                        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 group-hover:opacity-10 transition-opacity duration-300 rounded-2xl"></div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AvailableCounter;
